<template>
  <BContainer class="my-5">
    <AppHeader />

    <!-- 主要內容 -->
    <BRow>
      <BCol lg="9">
        <router-view />
      </BCol>

      <!-- 側邊欄 -->
      <BCol lg="3">
        <!-- 關於我 -->
        <BCard class="mb-4 about-card">
          <BCardBody>
            <BCardTitle tag="h4"><B>嘎嘎狗</B></BCardTitle>
            <BCardText>
              歡迎來到嘎嘎狗部落格！這裡分享技術文章、生活點滴和各種有趣的事物。
            </BCardText>
            <!-- 新增文章按鈕 -->
            <BButton v-if="auth.isLoggedIn" variant="primary" class="mt-3" @click="goToAppend">
              <i class="fas fa-pen me-2"></i> 新增文章
            </BButton>
          </BCardBody>
        </BCard>
      </BCol>
    </BRow>
  </BContainer>
  <!-- 頁腳 -->
  <AppFooter />
</template>

<script setup>
import { useAuthStore } from '@/stores/auth'
import AppHeader from "@/components/layout/AppHeader.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
import { useRouter } from "vue-router";
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BCardTitle,
  BCardText,
  BButton,
} from "bootstrap-vue-next";

const router = useRouter();
const auth = useAuthStore()

// 跳轉到 /append
const goToAppend = () => {
  router.push("/append");
};
</script>

<style scoped>
/* 自定義「關於我」卡片背景樣式 */
.about-card {
  position: relative;
  overflow: hidden;
  background-image: url("@/assets/images/aboutbg.jpg");
  background-size: cover; /* 確保圖片覆蓋整個卡片 */
  background-position: center;
  color: black; /* 確保文字在背景上可讀 */
}

.about-card .b-card-body {
  position: relative;
  z-index: 1; /* 確保內容在背景圖之上 */
}

.about-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.979); /* 調整透明度，讓背景圖不會太顯眼 */
  backdrop-filter: blur(60px); /* 模糊背景 */
  pointer-events: none; /* 防止偽元素阻擋點擊操作 */
  opacity: 0.1; /* 調整透明度，讓浮水印不會太顯眼 */
}

/* 關於我標題樣式 */
.about-title {
  color: #2e7d32; /* 設置文字顏色 */
}
</style>
